import { UserApi, User } from '@models/authentication/User';

export const toLogin = (x: UserApi): User => ({
  accessToken: x.access_token,
  tokenType: x.token_type,
  expiresIn: x.expires_in,
  refreshToken: x.refresh_token,
  userName: x.userName,
  email: x.email,
  fullName: x.fullName,
  rol: x.rol,
  rolId: x.rol_id,
  system: x.system,
  systemId: Number(x.systemId),
  subsystemId: Number(x.subsystemId),
});